/**
 *
 * Processes
 *
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { Input, Select, Button, Space, Row, Col, message, Spin, Descriptions, Dropdown, Tooltip } from "antd"
import { Form } from "@ant-design/compatible"
import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectMeasureSimple,
  makeSelectIsLoading,
  makeSelectIsLoadingMeasure,
  makeSelectIsLoadingReprocess,
} from "./selectors"
import alertSvg from "../../../images/alert.svg"

import {
  getMeasureSimpleWatcher, reprocessMeasureWatcher, updateMeasureWatcher
} from "./actions"
// import coolboxLogo from '../../../images/coolbox_logo.png';
import "@ant-design/compatible/assets/index.css"
import FormItem from "antd/es/form/FormItem"
import "./index.less"
import important from "images/HeaderIcons/Important.svg"
import { validate } from "../../../utils/functions"
import { DownOutlined, RightOutlined } from "@ant-design/icons"
import { Link } from "react-router-dom"
import ModalCustom from "../../../components/ModalCustom"


/* eslint-disable react/prefer-stateless-function */
export class Processes extends React.Component {
  state = {
    inputValue: "",
    modalDesOpen: false,
    textAction: "",
    disabledOk: true,
    action: '',
    statusDetail: false,
    isActionOpen: false
  }

  handleInputChange(event) {
    if (event.target.value >= 0) {
      this.setState({
        inputValue: event.target.value,
        textAction: "",
      });
    }


  }
  searchMeasure = () => {
    const { inputValue } = this.state;
    this.setState({ statusDetail: true })
    this.props.getMeasureSimpleWatcher({ idMeasure: inputValue })
    console.log('measureSimple', this.props.measureSimple);
    //message.error("La medición no existe en el sistema.",2)

  }
  handleMenuClick = (e) => {
    this.setState({ isActionOpen: false })
    if (e.key == 1 || e.key == 2) {
      this.setState({ modalDesOpen: true, action: e.key, disabledOk: true, textAction: "" });
    }

  };
  validateText = () => {
    const { action, textAction } = this.state;

    const textValid = action == 1 ? 'desoficializar' : 'reprocesar'
    console.log(slug(textAction), textValid);
    (slug(textAction) == textValid) ?
      this.setState({ disabledOk: false }) : this.setState({ disabledOk: true })


  }
  handleAction = () => {
    const { inputValue, action } = this.state;
    if (action == 1) {
      this.props.updateMeasureWatcher({ id_measure: inputValue })
    } else {
      this.props.reprocessMeasureWatcher({ id_measure: inputValue })
    }

    /*   this.setState({
        inputValue: "",
        statusDetail: false
      }); */



  };


  ButtonActionClick = () => {
    this.setState({ isActionOpen: true });
  };
  componentDidUpdate(prevProps) {
    console.log(prevProps.isLoadingMeasure ,this.props.isLoadingMeasure)
    if ((prevProps.isLoadingReprocess && !this.props.isLoadingReprocess) ||
      (prevProps.isLoadingMeasure && !this.props.isLoadingMeasure)) {
      this.setState({
        inputValue: "",
        statusDetail: false,
        modalDesOpen: false
      });
    }
  }
  render() {
    const { inputValue, modalDesOpen, textAction, disabledOk, action, statusDetail, isActionOpen } = this.state;
    const isButtonDisabled = inputValue === '';
    const measure = this.props.measureSimple[0]
    const icon = isActionOpen ? <DownOutlined /> : <RightOutlined />;
    /*  if(!this.props.isLoadingMeasure && !this.props.isLoadingReprocess){
       this.setState({ modalDesOpen: false });
     } */

    const items = [
      {
        label: 'Desoficializar medición',
        key: '1',
        disabled: this.props.measureSimple.length > 0 ? [1, 2, 3, 4].includes(measure.id_measure_status) : false,
        tooltip: this.props.measureSimple.length > 0 ? [1, 2, 3, 4].includes(measure.id_measure_status) ? 'La medición no se encuentra oficializada' : false : false,
      },
      {
        label: 'Reprocesar medición',
        key: '2',
        disabled: this.props.measureSimple.length > 0 ? [1, 2, 5].includes(measure.id_measure_status) : false,
        tooltip: this.props.measureSimple.length > 0 ? [5].includes(measure.id_measure_status) ? 'La medición se encuentra oficializada.' : false : false,
      },
    ];
    const menuProps = {
      items: items.map(item => ({
        ...item,
        label: (
          <Tooltip title={item.tooltip} placement="right">
            {item.label}
          </Tooltip>
        ),
      })),
      onClick: this.handleMenuClick,
    };
    return (
      <React.Fragment>
        <Row>
          <Col span={13}>
            <Row>
              <Col span={24}>
                <div className="container-process">
                  <Form layout="vertical" className="">
                    <label>ID de la medición</label>
                    <div style={{ marginTop: 8 }}>
                      <Space.Compact block >
                        <Input
                          style={{
                            width: '30%',
                          }}
                          placeholder="Ejm: 9999"
                          type="number"
                          className="input-number"
                          value={inputValue}
                          onChange={(event) => this.handleInputChange(event)}
                        />
                        <Button type="primary" disabled={isButtonDisabled} onClick={() => this.searchMeasure()}>Buscar</Button>
                      </Space.Compact>
                    </div>
                  </Form>
                </div>
              </Col>
              <Col span={24}>
                <div className="container-process" style={{ marginTop: 14 }} >
                  {this.props.isLoading ? (
                    <div className="loadingSpin">
                      <Spin size="large" />
                    </div>
                  ) : (this.props.measureSimple.length > 0 && statusDetail ?
                    <Form layout="vertical" >
                      <label>Información de la medición</label>
                      <Descriptions column={2} style={{ marginTop: 14, marginBottom: 10 }} >
                        <Descriptions.Item label="Nombre">{measure.name}</Descriptions.Item>
                        <Descriptions.Item label="Empresa">{measure.name_company}</Descriptions.Item>
                        <Descriptions.Item label="Indicador">{measure.name_survey_type}</Descriptions.Item>
                        <Descriptions.Item label="Alcance">{measure.scope_type}</Descriptions.Item>
                        <Descriptions.Item label="Fecha">{measure.date_start} - {measure.date_end} </Descriptions.Item>
                        <Descriptions.Item label="Estado" className={slug(measure.measure_status)}>{measure.measure_status}</Descriptions.Item>
                      </Descriptions>
                      <Dropdown menu={menuProps}
                        type="primary" trigger={['click']}
                        onVisibleChange={(visible) => {
                          visible ? this.setState({ isActionOpen: true }) : this.setState({ isActionOpen: false })
                        }}>
                        <Button type="primary" onClick={this.ButtonActionClick}>
                          <Space>
                            Acciones
                            {icon}
                          </Space>
                        </Button>
                      </Dropdown>
                      <ModalCustom
                        modalOpen={modalDesOpen}
                        showFooter
                        onOk={() => {
                          this.handleAction()
                        }}
                        isLoadingButton={this.props.isLoadingMeasure || this.props.isLoadingReprocess}
                        textButton={action == 1 ? 'Desoficializar' : 'Reprocesar'}
                        disabledButton={disabledOk}
                        onCancel={() => this.setState({ modalDesOpen: false })} >
                        <img src={alertSvg} className="alertIcon" />
                        <span style={{ fontWeight: 600, fontSize: 14 }}>
                          ¿Estás seguro que deseas {action == 1 ? 'desoficializar' : 'reprocesar'} la medición {measure.name}?
                        </span>
                        <p style={{ fontSize: 13, marginTop: 8 }}>
                          Para realizar la acción, escribe {action == 1 ? '“desoficializar”' : '“reprocesar”'}  en el siguiente recuadro:
                        </p>
                        <Input
                          maxLength={200}
                          onChange={(e) => {
                            this.setState({ textAction: e.target.value }, () => {
                              this.validateText();
                            });
                          }}
                          value={textAction}
                          placeholder={`Ingresa la palabra ${action == 1 ? '“desoficializar”' : '“reprocesar”'} aquí...`}/>
                      </ModalCustom>
                    </Form> : null)
                  }
                </div>
              </Col>
            </Row>

          </Col>
          <Col span={9}>
            <div className="info">
              <label className="text-info override"><img src={important} /> ¡Ten en cuenta!</label>
              <label className="" style={{ textDecoration: "underline" }}> Desoficializar medición</label>
              <div className="processText__tab-description color-black">
                Al <span>desoficializar</span> una medición, cualquier <span>cambio</span> que se realice
                en las {" "} secciones <span>“Organización”</span> y <span>“Cuestionarios”</span> podrá <span>afectar
                  los resultados</span> {" "} de la medición.
              </div>
              <label className="" style={{ textDecoration: "underline" }}> Reprocesar medición</label>
              <div className="processText__tab-description color-black">
                <span>Cualquier cambio</span> que se haya realizado en las secciones <span>Organización</span> y {" "}
                <span>Cuestionarios</span> de la organización podrá <span>afectar los resultados</span> de la medición a reprocesar.
              </div>
            </div>

          </Col>
        </Row>

      </React.Fragment>

    )
  }
}
const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  measureSimple: makeSelectMeasureSimple(),
  isLoadingMeasure: makeSelectIsLoadingMeasure(),
  isLoadingReprocess: makeSelectIsLoadingReprocess()
})
function mapDispatchToProps(dispatch) {
  return {
    getMeasureSimpleWatcher: (params) => dispatch(getMeasureSimpleWatcher(params)),
    updateMeasureWatcher: (params) => dispatch(updateMeasureWatcher(params)),
    reprocessMeasureWatcher: (params) => dispatch(reprocessMeasureWatcher(params))

  }

}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "Processes", reducer })
const withSaga = injectSaga({ key: "Processes", saga })
export default compose(withReducer, withSaga, withConnect)(Processes);
